import React from 'react';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
import Text from 'components/base/Text';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';

const BranchStateTag = styled(Flex)`
  ${({ backgroundColor }) =>
    backgroundColor ? `background-color ${getColor(backgroundColor)}` : ''};
  ${({ borderColor }) =>
    borderColor ? `border: 1px solid ${getColor(borderColor)}` : ''};
  box-sizing: border-box;
  border-radius: 3px;
  padding: 0.3rem 0.6rem;
  max-width: fit-content;
`;

const StyledText = styled(Text)`
  text-transform: capitalize;
`;

const GreenTag = ({ mt = 'no-space', text }) => {
  return (
    <BranchStateTag
      borderColor='madang'
      backgroundColor='feta'
      justify='center'
      items='center'
      mt={mt}
    >
      <Icon name='branch' size='x-small' color='malachite' />
      <StyledText size='small' color='funGreen' ml='0.5rem'>
        {text}
      </StyledText>
    </BranchStateTag>
  );
};

const BlueTag = ({ mt = 'no-space', text }) => {
  return (
    <BranchStateTag borderColor='nepal' justify='center' items='center' mt={mt}>
      <Icon name='branch' size='x-small' color='nepal' />
      <StyledText size='small' color='waikawaGray' ml='0.5rem'>
        {text}
      </StyledText>
    </BranchStateTag>
  );
};

const GrayTag = ({ mt = 'no-space', text }) => {
  return (
    <BranchStateTag
      backgroundColor='catskillWhite'
      justify='center'
      items='center'
      mt={mt}
    >
      <Icon
        name={text === 'stale' ? 'branch' : 'erroroutline'}
        size='x-small'
        color='nepal'
      />
      <StyledText size='small' color='osloGray'>
        {text}
      </StyledText>
    </BranchStateTag>
  );
};

export const getBranchStateTag = (state, props) => {
  switch (state) {
    case 'active':
      return <BlueTag {...props} text={state} />;
    case 'merged':
    case 'deployed':
      return <GreenTag {...props} text={state} />;
    case 'deleted':
    case 'stale':
      return <GrayTag {...props} text={state} />;
  }
};
